<template>
  <div class="row pr-4">
    <div class="col-12">
      <PageTitle title="MEUS PRÊMIOS" />
    </div>

    <div class="col-12 text-right">
      <button class="btn btn-primary" @click="novaPremio()">
        <i class="fas fa-plus"></i>
        Adicionar novo prêmio
      </button>
    </div>

    <div class="col-12 mt-2">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-center">Foto</th>
            <th>Nome do prêmio</th>
            <th>Descrição</th>
            <th class="text-center">Pontos</th>
            <th class="text-center">Cont. Qtd. / Qtd</th>
            <th class="text-center" style="width: 130px;">Status</th>
            <th class="text-center">Criado</th>
            <th class="text-center" style="width: 130px;">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in premios" :key="i" v-show="premios.length > 0">
            <td class="text-center align-middle">
              <img :src="formatarUrlImagrm(item.premio_fotos[0])" :alt="item.nome_premio" width="50px">
            </td>

            <td class="align-middle">
              {{ item.nome_premio }}
            </td>

            <td class="align-middle">
              <span v-b-tooltip.hover :title="item.descricao">{{ contarCaracteres(item.descricao, 50) }}</span>
            </td>

            <td class="text-center align-middle">
              {{ item.pontos }} ponto(s)
            </td>

            <td class="text-center align-middle">
              {{ item.controlar_qtd == 1 ? 'Sim' : 'Não' }} / 
              {{ item.controlar_qtd == 1 ? item.qtd : 'Qtd. ilimitada'}}
            </td>

            <td class="text-center align-middle">
              <span :class="item.status == true ? 'statusAtivo' : 'statusInativo'">
                {{ item.status == true ? 'Ativo' : 'Inativo' }}
              </span>
              <span 
                class="cursor-pointer ml-3" 
                v-b-tooltip.hover :title="item.status == true ? 'Inativar' : 'Ativar'"
                @click="alterarStatus(item.id)"
              >
                <i class="fas fa-sync"></i>
              </span>
            </td>

            <td class="text-center align-middle">
              {{ formatarData(item.created_at) }}
            </td>
            <td class="text-center align-middle">
              
              <button class="btn btn-primary mr-2 ml-2" v-b-tooltip.hover title="Editar" @click="editarPremio(item)">
                <i class="fas fa-edit"></i>
              </button>

              <button 
                :class=" item.premio_solicitado.length > 0 ? 'btn btn-danger disabledColor' : 'btn btn-danger'" 
                v-b-tooltip.hover 
                :title="item.premio_solicitado.length > 0 ? 'Você não pode excluir esse prêmio, pois já tem pedido solicitado desse prêmio!' : 'Excluir'" 
                @click="excluirPremio(item.id, item.premio_solicitado)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-show="premios.length == 0">
            <td colspan="8" class="text-center">
              <span>Você não tem prêmio(s) cadastrado(s)!</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

     <b-modal
        :title="this.fields.id == null ? 'Novo premio' : 'Atualizar prêmio'"
        size="lg"
        id="modal-meus-premios"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
        hide-footer
      >
        <div class="row">
          <div class="col-12" v-if="validUpdate">
            <div class="alert alert-danger" role="alert">
              Você não pode editar todos os campos desse prêmio, pois já tem pedido solicitado desse prêmio!
            </div>
          </div>

          <div class="col-12">
            <label>Nome do prêmio</label>
            <input type="text" v-model="fields.nome_premio" class="form-control" placeholder="Nome do prêmio" maxlength="150" :disabled="validUpdate">
          </div>

          <div class="col-12">
            <label>Descrição</label>
            <textarea v-model="fields.descricao" class="form-control" rows="4" maxlength="255" :disabled="validUpdate"></textarea>
          </div>

          <div class="col-4 mt-2">
            <label>Pontos</label>
            <input type="text" v-model="fields.pontos" class="form-control" placeholder="XX" v-mask="'###########'">
          </div>

          <div class="col-4 text-center mt-2">
            <label>Controlar quantidade ({{fields.controlar_qtd==true?'Sim':'Não'}})</label>
            <input type="checkbox" v-model="fields.controlar_qtd" class="form-control">
          </div>

          <div class="col-4 mt-2" v-if="fields.controlar_qtd == true">
            <label>Quantidade disponível</label>
            <input type="text" v-model="fields.qtd" class="form-control" placeholder="XX" v-mask="'###########'">
          </div>

          <div class="col-12 mt-2">
            <label>Foto(s)</label>
            <input type="file" class="form-control" @change="uploadImage()" ref="file" id="file" accept="image/x-png" :disabled="validUpdate">
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-2 text-center mt-2" v-for="(itemFoto, i) in fields.fotos" :key="i">
                <span class="excluirFoto" @click="removerFoto(i, itemFoto)" v-if="validUpdate == false">
                  <i class="fas fa-times-circle"></i>
                </span>
                <img :src="formatarUrlImagrm(itemFoto)" width="50px">
              </div>
            </div>
          </div>

          <div class="col-12 text-center mt-4">
            <button class="btn btn-success btn-block" @click="sendForm()">
              {{ this.fields.id == null ? 'Criar ' : 'Atualizar ' }}prêmio
            </button>
          </div>
        </div>
      </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'LojistaMeusPremios',
  mixins: [makeToast],
  components: {
    PageTitle
  },

  data() {
    return {
      validUpdate: false,
      premios: [],
      fields: {
        id: null,
        nome_premio: '',
        descricao: '',
        pontos: '',
        controlar_qtd: false,
        qtd: null,
        status: true,
        fotos: [],
        fotos_remover: [],
        construp_user_id: null,
      },
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.get();
  },

  methods: {
    get() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/meusPremios', this.dadosUsuario.id)
        .then((response) => {
          this.premios = response.data;
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao buscar seu(s) prêmio(s)!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    sendForm() {
      var valid = this.validarForm();

      if(valid == true) {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('shopkeeper/sendFormPremio', this.fields)
          .then((response) => {
            if(response.data.error == false) {
              this.$bvModal.hide('modal-meus-premios');
              this.makeToast('Sucesso', response.data.message, 'success');
              this.get();
            } else {
              this.makeToast('Erro', response.data.message, 'danger');
              this.$store.dispatch('endLoader');
            }
          })
          .catch(() => {
            this.makeToast('Erro', 'Houve um erro ao buscar seus prêmios!', 'danger');
            this.$store.dispatch('endLoader');
          });
      }
    },
    alterarStatus(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/alterarStatusPremio', id)
        .then((response) => {
          if(response.data.error == false) {
            this.makeToast('Sucesso', 'Status atulizado!', 'success');
            this.get();
          } else {
            this.makeToast('Erro', 'Houve um erro ao atualizar o status!', 'danger');
            this.$store.dispatch('endLoader');
          }
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao atualizar o status!', 'danger');
          this.$store.dispatch('endLoader');
        });
    },
    excluirPremio(id, vinculo) {
      if(vinculo.length > 0) {
        this.makeToast('Erro', 'Você não pode excluir esse prêmio, pois já tem pedido solicitado desse prêmio!', 'danger');
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/excluirPremio', id)
        .then((response) => {
          if(response.data.error == false) {
            this.makeToast('Sucesso', 'Prêmio excluído!', 'success');
            this.get();
          } else {
            this.makeToast('Erro', 'Houve um erro ao excluir o prêmio!', 'danger');
            this.$store.dispatch('endLoader');
          }
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao excluir o prêmio!', 'danger');
          this.$store.dispatch('endLoader');
        });
    },
    removerFoto(i, item) {
      if(!this.fields.fotos_remover) {
        this.fields.fotos_remover = [];
      }

      this.fields.fotos_remover.push(item);
      this.fields.fotos = this.fields.fotos.filter((elemento, index) => index !== i);
    },
    uploadImage() {
      const formData = new FormData();
      this.imageSelected = this.$refs.file.files[0];
      formData.append('file', this.imageSelected);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/uploadFileApiAppPremio', formData)
        .then((response) => {
          if(response.data.error == true) {
            this.makeToast('Oops!', response.data.message, 'danger');
          } else {
            this.fields.fotos.push({foto: response.data.foto});
          }
        })
        .catch(() => {
          this.makeToast('Oops!', 'Não foi possível inserir sua imagem, tente novamente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    novaPremio() {
      this.limparCampos();
      this.$bvModal.show('modal-meus-premios');
    },
    formatarUrlImagrm(path) {
      return 'https://construp-imagens.s3.us-east-2.amazonaws.com/premio/'+path.foto;
    },
    editarPremio(item) {
      this.fields.id = item.id;
      this.fields.nome_premio = item.nome_premio;
      this.fields.descricao = item.descricao;
      this.fields.pontos = item.pontos;
      this.fields.controlar_qtd = item.controlar_qtd;
      this.fields.qtd = item.qtd;
      this.fields.status = item.status == 1 ? true : false;
      this.fields.fotos = item.premio_fotos;
      this.fields.fotos_remover = [];
      this.fields.construp_user_id = this.dadosUsuario.id;

      this.validUpdate = item.premio_solicitado.length > 0 ? true : false;
      this.$bvModal.show('modal-meus-premios');
    },
    contarCaracteres(texto, qtd) {
      var resultado = texto.substring(0, qtd);
      var pontos = texto.length > qtd ? '...' : '';

      return resultado + pontos;
    },
    limparCampos() {
      this.fields.id = null;;
      this.fields.nome_premio = '';
      this.fields.descricao = '';
      this.fields.pontos = '';
      this.fields.controlar_qtd = false;
      this.fields.qtd = null;
      this.fields.status = true;
      this.fields.fotos = [];
      this.fields.fotos_remover = [];
      this.fields.construp_user_id = this.dadosUsuario.id;
    },
    validarForm() {
      var valid = true;

      if(this.fields.nome_premio == '') {
        this.makeToast('Erro', 'Informe o nome do prêmio!', 'danger');
        valid = false;
      }

      if(this.fields.descricao == '') {
        this.makeToast('Erro', 'Informe a descrição do prêmio!', 'danger');
        valid = false;
      }

      if(this.fields.fotos.length == 0) {
        this.makeToast('Erro', 'Informe a(s) foto(s) do prêmio!', 'danger');
        valid = false;
      }

      if(this.fields.pontos == '' || this.fields.pontos == null) {
        this.makeToast('Erro', 'Informe o(s) ponto(s) do prêmio!', 'danger');
        valid = false;
      }

      if((this.fields.controlar_qtd == true) && (this.fields.qtd == null || this.fields.qtd == '')) {
        this.makeToast('Erro', 'Informe a quantidade do prêmio disponível!', 'danger');
        valid = false;
      }

      return valid;
    },
    formatarData(dataHoraOriginal) {
      let dataHora = new Date(dataHoraOriginal);
      let opcoesFormato = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };

      let dataHoraFormatada = new Intl.DateTimeFormat('pt-BR', opcoesFormato).format(dataHora);

      return dataHoraFormatada;
    }
  }
}
</script>

<style scoped>
.statusAtivo {
  background: #3bb53b;
  color: #FFF;
  padding: 5px 10px;
  border-radius: 4px;
}
.statusInativo {
  background: #e71a1a;
  color: #FFF;
  padding: 5px 10px;
  border-radius: 4px;
}
.excluirFoto {
  cursor: pointer;
  background: red;
  color: #FFF;
  border-radius: 3px;
  padding: 0px 4px;
  position: absolute;
  z-index: 9;
  top: -5px;
  right: 25%;
}
.disabledColor {
  background-color: #dc354570;
  border: #dc354570;
}
</style>